import { Tooltip } from "@material-ui/core";
import TeacherPortalVerticalProgressBar from "./VerticalProgressBar";

const TeacherPortalVerticalProgressBarWithTooltip = (props) => (
    <Tooltip title={props.tooltipString}>
        <TeacherPortalVerticalProgressBar floatProgress={props.floatProgress} />
    </Tooltip>
);

export default TeacherPortalVerticalProgressBarWithTooltip;